"use client";

import { useEffect, useState } from "react";
import { ProfileInitials } from "./ProfileIntials";
import { getStudentProfilePic } from "@/api/query/dashboard";

interface ProfileImageProps {
  studentId: number;
  firstName: string;
  className?: string;
  initialsClassName?: string;
}

export function ProfileImage({
  studentId,
  firstName,
  className = "w-10 h-10",
  initialsClassName,
}: ProfileImageProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchProfileImage = async () => {
      try {
        setIsLoading(true);
        const url = await getStudentProfilePic(studentId);
        if (url) {
          setImageUrl(url);
          setError(false);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching profile image:", err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileImage();
  }, [studentId]);

  if (imageUrl && !error) {
    return (
      <img
        src={imageUrl || "/placeholder.svg"}
        alt={firstName}
        className={`${className} rounded-full object-cover`}
      />
    );
  }

  return <ProfileInitials name={firstName} className={initialsClassName} />;
}
